import React from "react"
import { REQUIREMENT_DATA } from "../MembershipJourney/requirementData"
import { resolveUrlForArticles } from "../MembershipJourney/utils/urlUtils"
import {
  getStatusBackgroundColor,
  getStatusColor,
} from "../MembershipJourney/utils/displayUtils"
import {
  ActionButton,
  ActionButtonText,
  RequirementActions,
  RequirementCardStyled,
  RequirementDescription,
  RequirementHeader,
  RequirementTitle,
  StatusBadgeSmall,
  StatusBadgeText,
  TextButton,
} from "../MembershipJourney/Styles/ProgressTracker.styles"
import { VIEW_APPLICATION_LABEL } from "../../../utils/prospect/ptmApplicationStatus"

// Same catalog the Associate journey and the reciprocity card use for a
// Membership application, so Course Curriculum does not invent a second look.
const ENROLLMENT = REQUIREMENT_DATA.level3.requirements.enrollment

const IN_REVIEW_STATUSES = new Set([
  "submitted",
  "under_review",
  "changes_requested",
])

export const memberApplicationStatusPresentation = status => {
  const key = String(status || "").toLowerCase()
  if (IN_REVIEW_STATUSES.has(key)) {
    const copy = ENROLLMENT.statuses.submitted
    return {
      statusKey: "submitted",
      label: copy.label,
      message: copy.message,
    }
  }
  if (key === "approved") {
    const copy = ENROLLMENT.statuses.approved
    return {
      statusKey: "approved",
      label: copy.label,
      message: copy.message,
      secondaryLinkText: copy.secondaryLinkText,
      secondaryLinkUrl: copy.secondaryLinkUrl,
    }
  }
  return null
}

const MemberApplicationStatusCard = ({ status, onViewApplication }) => {
  const presentation = memberApplicationStatusPresentation(status)
  if (!presentation) return null

  return (
    <RequirementCardStyled data-testid="member-application-status">
      <RequirementHeader>
        <RequirementTitle>{ENROLLMENT.name}</RequirementTitle>
        <StatusBadgeSmall
          backgroundColor={getStatusBackgroundColor(presentation.statusKey)}
        >
          <StatusBadgeText textColor={getStatusColor(presentation.statusKey)}>
            {presentation.label}
          </StatusBadgeText>
        </StatusBadgeSmall>
      </RequirementHeader>
      <RequirementDescription>{presentation.message}</RequirementDescription>
      <RequirementActions>
        <ActionButton type="button" onClick={onViewApplication}>
          <ActionButtonText>{VIEW_APPLICATION_LABEL}</ActionButtonText>
        </ActionButton>
        {presentation.secondaryLinkText && presentation.secondaryLinkUrl ? (
          <TextButton
            as="a"
            href={resolveUrlForArticles(presentation.secondaryLinkUrl)}
            target="_blank"
            rel="noopener noreferrer"
          >
            {presentation.secondaryLinkText}
          </TextButton>
        ) : null}
      </RequirementActions>
    </RequirementCardStyled>
  )
}

export default MemberApplicationStatusCard
